module.exports = __webpack_public_path__ + "img/avatar-android.png";